import { AdminRoute } from "@/components/AdminRoute";
import { AppLayout } from "@/components/AppLayout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AuthProvider } from "@/contexts/AuthContext";
import { CnpjDetailPage } from "@/pages/CnpjDetailPage";
import { IntegrationTokensPage } from "@/pages/IntegrationTokensPage";
import { LoginPage } from "@/pages/LoginPage";
import { SearchPage } from "@/pages/SearchPage";
import { SocioPage } from "@/pages/SocioPage";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

/** Raiz da aplicação: roteamento e provedor de autenticação. */
export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<SearchPage />} />
            <Route path="/socio" element={<SocioPage />} />
            <Route path="/cnpj/:cnpj" element={<CnpjDetailPage />} />
            <Route
              path="/tokens"
              element={
                <AdminRoute>
                  <IntegrationTokensPage />
                </AdminRoute>
              }
            />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
